import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Reveal, PhotoSlot } from "@/components/shared";

export default function CustomSections({ page }) {
  const [sections, setSections] = useState([]);

  useEffect(() => {
    api
      .get(`/sections?page=${page}`)
      .then((r) => setSections(r.data))
      .catch(() => {});
  }, [page]);

  if (sections.length === 0) return null;

  return (
    <div data-testid={`custom-sections-${page}`}>
      {sections.map((section) => {
        if (section.type === "cta") {
          return (
            <section key={section.id} className="border-t border-white/5 px-6 py-20 md:px-12" data-testid={`custom-section-${section.id}`}>
              <div className="mx-auto max-w-6xl">
                <Reveal>
                  <div className="flex flex-col items-start gap-8 rounded-lg border border-gold/25 bg-coal/60 p-10 md:flex-row md:items-center md:justify-between">
                    <div>
                      <h2 className="max-w-xl text-2xl font-bold tracking-tight text-ivory sm:text-3xl">
                        {section.title}
                      </h2>
                      {section.text && (
                        <p className="mt-4 max-w-lg text-sm leading-relaxed text-ivory/55">
                          {section.text}
                        </p>
                      )}
                    </div>
                    {section.button_label && section.button_url && (
                      <Link to={section.button_url} className="btn-primary shrink-0" data-testid={`custom-section-cta-${section.id}`}>
                        {section.button_label}
                      </Link>
                    )}
                  </div>
                </Reveal>
              </div>
            </section>
          );
        }
        if (section.type === "image_texte") {
          return (
            <section key={section.id} className="border-t border-white/5 px-6 py-20 md:px-12" data-testid={`custom-section-${section.id}`}>
              <div className="mx-auto grid max-w-6xl items-center gap-12 lg:grid-cols-2">
                <Reveal>
                  <PhotoSlot src={section.image} alt={section.title} ratio="aspect-[4/3]" />
                </Reveal>
                <Reveal delay={0.1}>
                  <h2 className="text-2xl font-bold tracking-tight text-ivory sm:text-3xl">
                    {section.title}
                  </h2>
                  {section.text && (
                    <p className="mt-6 max-w-lg text-sm leading-relaxed text-ivory/55">
                      {section.text}
                    </p>
                  )}
                </Reveal>
              </div>
            </section>
          );
        }
        return (
          <section key={section.id} className="border-t border-white/5 px-6 py-20 md:px-12" data-testid={`custom-section-${section.id}`}>
            <div className="mx-auto max-w-3xl">
              <Reveal>
                <h2 className="text-2xl font-bold tracking-tight text-ivory sm:text-3xl">
                  {section.title}
                </h2>
                {section.text && (
                  <p className="mt-6 whitespace-pre-line text-sm leading-relaxed text-ivory/55">
                    {section.text}
                  </p>
                )}
              </Reveal>
            </div>
          </section>
        );
      })}
    </div>
  );
}
